module.exports = __webpack_public_path__ + "static/media/category-hero.8311e7f1.png";